const axios = require("axios");
function showProgressIndicator() {
    document.getElementById("overlay").style.display = "flex";
}

function hideProgressIndicator() {
    document.getElementById("overlay").style.display = "none";
}
export default {
    async request(options, showLoading = true) {
        options.headers = {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        };
        // Let the browser/WebView add the multipart boundary for FormData.
        try {
            if (showLoading) {
                showProgressIndicator();
            }
            let response = await axios(options);

            return response;
        } catch (error) {
            console.error("Error:", error);
            throw error;
        } finally {
            hideProgressIndicator();
        }
    },
};
